import Vue from 'vue';
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
import toast from '@/utils/toast';
import Katex from '@/pages/uc-web/utils/directives';
import './styles/common.css';
import 'katex/dist/katex.min.css';
import App from './App.vue';
// import Katex from '@/utils/directives';
import store from './store';
import router from './router';
import 'element-ui/lib/theme-chalk/index.css';
import { jsBridgeForSSAI } from '@/utils/index';

Vue.use(Katex);
Vue.use(router);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$toast = toast;
Vue.prototype.echarts = echarts;

router.beforeEach(async (to, from, next) => {
  console.log(to);
  if (to.name === 'HomePage') {
    console.log(to.query.authKey, 'token值');
    const userToken = to.query.authKey || localStorage.getItem('user_token');
    localStorage.setItem('user_token', userToken);
  }
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
window.clickHome = (data) => {
  console.log(data, 'data');
  let home = '';
  try {
    home = data;
  } catch (e) {
    console.log(e);
    home = data;
  }
  if (home) {
    window.location.href = home;
    jsBridgeForSSAI('getData', {
      key: 'UCINFO',
    }, 'getUcInfo');
  }
};
window.getUcInfo = (data) => {
  if (data !== undefined) {
    const ucInfo = JSON.parse(data).data.UCINFO;
    localStorage.setItem('real_name', ucInfo.real_name);
    localStorage.setItem('account_id', ucInfo.account_id);
    localStorage.setItem('school_id', ucInfo.school_id);
    localStorage.setItem('user_token', ucInfo.user_token);
    localStorage.setItem('school_nature_id', ucInfo.school_nature_id);
  }
};
